import * as React from 'react';
import { Form } from 'react-final-form';
import { Instance } from 'mobx-state-tree';
import { Pharmacy } from '../../store/models/Pharmacy';
import styled from '@emotion/styled';
import { CheckboxInputFormField, DateInputFormField, SelectInputFormField } from '../common/form';
import { ActionCode, Page, TLCode } from '../../common/enums';
import { Button, Intent, MenuItem } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { IconNames } from '@blueprintjs/icons';
import { BlackPointSearchCriteria } from '../../store/BlackPointStore';
import { toJS } from 'mobx';
import { BlackPointStatus } from '../../store/models/BlackPointStatus';
import { IItemRendererProps } from '@blueprintjs/select';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { TranslatedMessage } from '../common/translation';
import { Link } from 'react-router-dom';
import { css } from 'emotion';
import moment from 'moment';

const DivDate = styled.div`
  & .bp3-label {
    margin-top: -10px;
  },
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: row;
  width: 60%;
  margin-right: 5%;
  padding-bottom: 5px;
`;

const DivRight = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
`;
const DivSpacer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 50px;
  .bp3-icon {
    margin-right: 3px;
  }
`;

interface BlackPointSearchFormProps extends WithTranslateProps {
  search: (criteria: any) => void;
  searchCriteria: Instance<typeof BlackPointSearchCriteria> | null;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  isLoading: boolean;
  getPharmacyById: (id: number) => any;
  userRoles: string[];
}

interface BlackPointSearchFormState {
  searchCriteria: Instance<typeof BlackPointSearchCriteria>;
}

class BlackPointSearchForm extends React.Component<BlackPointSearchFormProps, BlackPointSearchFormState> {
  renderPharmacyMenuItem(
    item: Instance<typeof BlackPointStatus>,
    { handleClick, index, modifiers }: IItemRendererProps,
  ) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`pharmacy-${index}`} active={modifiers.active} onClick={handleClick} text={item.name!} />;
    } else {
      return null;
    }
  }

  render() {
    const { search, isLoading, pharmacyList, getPharmacyById, searchCriteria, translate, userRoles } = this.props;

    return (
      <Form
        initialValues={searchCriteria || {}}
        onSubmit={search}
        render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <DivLine>
              <DivLeft>
                {!userRoles.includes(ActionCode.PHARMACY_USER_CODE) && (
                  <SelectInputFormField
                    label={TLCode.BLACKPOINT_Pharmacy}
                    name="pharmacyId"
                    inline={true}
                    items={toJS(pharmacyList)}
                    itemValueGetter={(item: { pharmacyId: number; name: string }) => item.pharmacyId}
                    valueItemGetter={(value: number) => getPharmacyById(value)!}
                    inputValueRenderer={(item) => (item != null ? item.name! : '')}
                    itemRenderer={this.renderPharmacyMenuItem}
                    identifier={'pharmacyId'}
                    elementLabel={'name'}
                    allowEmpty={true}
                    labelSelectAnElement={translate(TLCode.ALL)}
                  />
                )}
                <DivDate>
                  <DateInputFormField
                    name="date"
                    label={TLCode.BLACKPOINT_Search_Date}
                    inline={true}
                    fill={true}
                    maxDate={moment()
                      .add(20, 'year')
                      .toDate()}
                  />
                </DivDate>
                <SimpleTextFormContent label={TLCode.BLACKPOINT_ToProcess} small={false}>
                  <CheckboxInputFormField name="treated" inline={true} />
                </SimpleTextFormContent>
                <Button
                  type={'submit'}
                  text={this.props.translate(TLCode.GENERAL_Search)}
                  intent={Intent.PRIMARY}
                  icon={IconNames.SEARCH}
                  disabled={isLoading}
                  className={css({ height: '30px' })}
                />
              </DivLeft>
              <DivRight>
                <Link to={Page.BlackPoints + '/-1'}>
                  <Button intent="primary">
                    <TranslatedMessage id={TLCode.Add} />
                  </Button>
                </Link>
                <DivSpacer></DivSpacer>
                <Link to={Page.BankHolidays}>
                  <Button intent="primary">
                    <TranslatedMessage id={TLCode.BANK_HOLIDAYS_Button} />
                  </Button>
                </Link>
              </DivRight>
            </DivLine>
          </form>
        )}
      />
    );
  }
}

export default withTranslate(BlackPointSearchForm);
